var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightCornerSimpleBg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 57,
    viewBox: "0 0 64 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2699_302675)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2699_302675",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -6,
    width: 231,
    height: 68
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 230.067,
    height: 66.697,
    transform: "matrix(-1 -8.8552e-08 -8.6308e-08 1 230.067 -5.49997)",
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2699_302675)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.4166 -5.68541L64.4722 -5.68541L64.4722 27.9383L31.4166 -5.68541Z",
    fill: "#992C21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4166 27.9381L64.4722 27.9381L64.4722 61.5713L31.4166 27.9381Z",
    fill: "#2161AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4167 61.5712L-1.62951 61.5712L-1.62951 27.938L31.4167 61.5712Z",
    fill: "#9E7E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4722 -5.68541L64.4722 27.9383L31.4166 27.9383L64.4722 -5.68541Z",
    fill: "#BD3728"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.62951 27.938L31.4167 27.938L31.4167 61.5712L-1.62951 27.938Z",
    fill: "#C59A2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9443 11.1312L31.4165 -5.68541L31.4165 27.9383L47.9443 11.1312Z",
    fill: "#CC5D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1928 27.9381L64.4722 47.5543L64.4722 61.5713L31.4166 27.9381L45.1928 27.9381Z",
    fill: "#0C4D91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6959 61.5713L31.4166 41.9551L31.4166 27.9381L64.4722 61.5713L50.6959 61.5713Z",
    fill: "#2161AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4167 61.5715L31.4167 41.9554L50.696 61.5716L31.4167 61.5715Z",
    fill: "#0C4D91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4168 70.9858L31.4168 41.9553L59.9487 70.9858L31.4168 70.9858Z",
    fill: "#0C4D91"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2699_302675"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(0 -5.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightCornerSimpleBg);
export default __webpack_public_path__ + "static/media/right-corner-simple-bg.9d43160520e0009434f79bf474d5bbe7.svg";
export { ForwardRef as ReactComponent };